/*
 * Public API Surface of ngx-signature-pad
 */

export * from './lib/ngx-signature-pad.service';
export * from './lib/ngx-signature-pad.component';
export * from './lib/ngx-signature-pad.module';
export * from './lib/models/signaturePadOptions';
